import React, { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import UpdateYearAndMajorForm from './UpdateYearAndMajorForm';
import '../ProfilePage.css';

function UpdateYearAndMajorCard() {
    // State to manage the visibility of the modal for updating year and major
    const [showModal, setShowModal] = useState(false);

    const handleOpenModal = () => setShowModal(true);
    const handleCloseModal = () => setShowModal(false);

    return (
        <>
            <Card className="profile-page-card rounded-0">
                <Card.Body>
                    <Card.Title className="profile-page-card-title">
                        Update Year/Major
                    </Card.Title>
                    <Card.Text className="text-center">
                        Click the <strong>Update</strong> button below to 
                        update your academic year and major! Note that this 
                        will only update your academic year and major as it 
                        appears on the Miami AI Tutor website. This will not 
                        update your academic year and major for any other 
                        purposes.
                    </Card.Text>
                    <div className="text-center">
                        {/* Button to open the modal for updating year and major */}
                        <Button
                            className="courses-card-button btn-lg rounded-0"
                            onClick={handleOpenModal}
                        >
                            Update
                        </Button>
                    </div>
                </Card.Body>
            </Card>
            {/* Pass the forceOpen prop to UpdateYearAndMajorForm */}
            <UpdateYearAndMajorForm forceOpen={showModal} onClose={handleCloseModal} />
        </>
    );
}

export default UpdateYearAndMajorCard;